import React from 'react';
import { Link } from 'react-router-dom';

export function LegalFooter({ className = '', minimal = false }) {
  const currentYear = new Date().getFullYear();
  
  if (minimal) {
    return (
      <div className={`text-xs text-muted-foreground text-center ${className}`}>
        <p>
          Secret Sauce is a trading name of Organisation Logic Limited, 
          England & Wales Company Registration Number: 12213127
        </p>
      </div>
    );
  }

  return (
    <footer className={`border-t border-border bg-card ${className}`} data-testid="legal-footer">
      <div className="container-custom py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-sm text-muted-foreground">
            <p className="font-medium text-foreground">© {currentYear} Secret Sauce</p>
            <p className="mt-1">The PATH Programme</p>
          </div>
          
          <div className="flex items-center gap-6 text-sm">
            <Link 
              to="/privacy" 
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms" 
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms of Service
            </Link>
            <a 
              href="mailto:hello@secretsauce.fyi" 
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Contact
            </a>
          </div>
        </div>
        
        <div className="mt-6 pt-6 border-t border-border">
          <p className="text-xs text-muted-foreground text-center">
            Secret Sauce is a trading name of Organisation Logic Limited, 
            England & Wales Company Registration Number: 12213127
          </p>
        </div>
      </div>
    </footer>
  );
}